import React, { useRef } from 'react';

const WORD = {
  accept: '.doc,.docx,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document',
  formats: 'Word (.doc, .docx) — 5 Mo max',
};
const SCAN = {
  accept: '.pdf,.jpg,.jpeg,.png,application/pdf,image/jpeg,image/png',
  formats: 'PDF, JPG ou PNG — 5 Mo max',
};

const FileField = ({ name, label, type, data, errors, onChange }) => {
  const ref = useRef(null);
  const file = data[name];
  const error = errors[name];
  return (
    <div className="form-group">
      <label>{label}<span className="required">*</span></label>
      <div
        className={`file-upload ${file ? 'has-file' : ''} ${error ? 'error' : ''}`}
        onClick={() => ref.current?.click()}
        role="button"
        tabIndex={0}
        onKeyDown={(e) => (e.key === 'Enter' || e.key === ' ') && ref.current?.click()}
      >
        <input
          type="file"
          ref={ref}
          accept={type.accept}
          onChange={(e) => e.target.files[0] && onChange({ [name]: e.target.files[0] })}
        />
        {file
          ? <span className="file-name">✓ {file.name}</span>
          : <span className="file-label">Choisir un fichier</span>}
        <div className="file-formats">{type.formats}</div>
      </div>
      {error && <span className="error-message">{error}</span>}
    </div>
  );
};

const Documents = (props) => (
  <>
    <h2>Documents</h2>
    <p className="section-desc">Les quatre pièces sont obligatoires.</p>

    <div className="form-row two-cols">
      <FileField name="cv" label="CV signé, avec références" type={WORD} {...props} />
      <FileField name="lettre_motivation" label="Lettre de motivation signée" type={WORD} {...props} />
      <FileField name="diplome_fichier" label="Diplôme (copie légalisée)" type={SCAN} {...props} />
      <FileField name="piece_identite" label="Pièce d'identité" type={SCAN} {...props} />
    </div>
  </>
);

export default Documents;
